import React, { FC, SVGProps } from 'react';

/** Butlr sensor icon — rounded pill with inner track and center indicator */
const Sensor: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 22 17.5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.25 1.5H8.75C4.74594 1.5 1.5 4.74594 1.5 8.75C1.5 12.7541 4.74594 16 8.75 16H13.25C17.2541 16 20.5 12.7541 20.5 8.75C20.5 4.74594 17.2541 1.5 13.25 1.5ZM8.75 0C3.91751 0 0 3.91751 0 8.75C0 13.5825 3.91751 17.5 8.75 17.5H13.25C18.0825 17.5 22 13.5825 22 8.75C22 3.91751 18.0825 0 13.25 0H8.75ZM3 8.75C3 5.57436 5.57436 3 8.75 3H13.25C16.4256 3 19 5.57436 19 8.75C19 11.9256 16.4256 14.5 13.25 14.5H8.75C5.57436 14.5 3 11.9256 3 8.75ZM8.75 4.5C6.40279 4.5 4.5 6.40279 4.5 8.75C4.5 11.0972 6.40279 13 8.75 13H13.25C15.5972 13 17.5 11.0972 17.5 8.75C17.5 6.40279 15.5972 4.5 13.25 4.5H8.75ZM10.07 7.62C9.95954 7.62 9.87 7.70954 9.87 7.81999V9.67C9.87 9.78045 9.95954 9.87 10.07 9.87H11.92C12.0305 9.87 12.12 9.78045 12.12 9.67V7.81999C12.12 7.70954 12.0305 7.62 11.92 7.62H10.07Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Sensor;
